import { isNonEmptyStringOrNumber } from '@thesavingsgroup/utils/isNonEmptyStringOrNumber';

import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { ToApplyStateFromVehicleSelectionParams } from '../types/ToApplyStateFromVehicleSelectionParams';

export const toApplyStateFromVehicleSelection = async (
  params: ToApplyStateFromVehicleSelectionParams,
): Promise<Partial<ApplyState>> => {
  const {
    params: { vehicleSelectionId },
    findVehicleSelectionById,
    fetchVehicleIdentifiers,
  } = params;

  const vehicle = findVehicleSelectionById(vehicleSelectionId);

  if (!vehicle) {
    return {};
  }

  const { make, model, trim, year } = await fetchVehicleIdentifiers(vehicle);

  const mileage = isNonEmptyStringOrNumber(vehicle.mileage)
    ? String(vehicle.mileage)
    : null;
  const payoffAmount = isNonEmptyStringOrNumber(vehicle.payoffAmount)
    ? String(vehicle.payoffAmount)
    : null;

  let searchVehicle: SearchVehicle;

  if (vehicle.vin) {
    searchVehicle = SearchVehicle.BY_VIN;
  } else if (vehicle.plate && vehicle.province) {
    searchVehicle = SearchVehicle.BY_LICENSE_PLATE;
  } else {
    searchVehicle = SearchVehicle.BY_MAKE_MODEL;
  }

  return {
    isHydrated: true,
    make,
    mileage,
    model,
    payoffAmount,
    plate: vehicle.plate,
    searchVehicle,
    state: vehicle.province,
    trim,
    vin: vehicle.vin,
    year,
  };
};
